import { connectListView, ListView } from "../../../UI/view/list-view";
import { liquidBillingErrorDS, liquidBillingManualDS } from "./liquid-billing-datasource";
import { CreateTransfer, CreateTransferDataSource } from "./liquid-create-transfer";
import { liquidBillingListColumns, liquidBillingListToolbar, liquidListFilters } from "./liquid-invoice-list";

export const liquidBillingErrorList = {
  name: 'liquidBillingErrorList',
  filters: liquidListFilters,
  columns: liquidBillingListColumns,
  additionalModals: [
    {
      form: CreateTransfer,
      repository: CreateTransferDataSource,
      name: 'createTransfer',
      title: 'Create Transfer',
    }
  ],
  toolbar: liquidBillingListToolbar('liquidBillingErrorList'),
} as ListView;

export const [LiquidBillingErrorList, LiquidBillingInvoiceDataSource] = connectListView(liquidBillingErrorList, liquidBillingErrorDS);